import { gql } from '@apollo/client';

export default gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      additionalDetails {
        value
        key
        itemRef
      }
      reference
      currency
      outbound(sortByDepartureDate: true) {
        ...leg
      }
      inbound(sortByDepartureDate: true) {
        ...leg
      }
      allBookingItems @client {
        ...product
        status
      }
      isPackage
      isLoyalty
      hotels {
        itemRef
      }
      payments(excludePayout: true, excludeBalance: true) {
        id
        refId
        currency
        currencyRate
        reference
        externalReference
        refundAvailable
        isSuccessful
        provider
        method
        amount
        availableRefundAmount
        transactionTimestamp
        refundProcessTimestamp
        paymentStatus
        createdRevision
      }
      passengers {
        email
        firstName
        lastName
      }
      customer {
        email
        firstName
        lastName
      }
    }
  }

  fragment leg on Leg {
    ...legFields
    addOnLeg {
      ...legFields
    }
  }

  fragment legFields on Leg {
    isThroughFare
    isSummatedFare
    trainNumber
    direction
    products {
      ...product
    }
    serviceType {
      code
      name
    }
  }

  fragment product on Product {
    uuid
    itemRef
    associatedItemRefs
    currency
    price
    isCancelled
    loyaltyPoints
    ticketNumber
    passenger {
      id
      type
    }
    tariffDetails {
      bucketCode
    }
    productFamily {
      code
      name
      familyGroup
    }
  }
`;
